import { api } from '@/lib/axios';
import { renderPdf, type PdfMode } from '@/lib/pdf';

// CONVERTI est conservé pour l'affichage des anciens devis (legacy) ; il n'est plus attribuable.
export type DevisStatut = 'BROUILLON' | 'ENVOYE' | 'ACCEPTE' | 'REFUSE' | 'A_REVISER' | 'CONVERTI';

export type LigneDevis = {
  id?: string;
  designation: string;
  unite?: string | null;
  quantite: number;
  prix_unitaire: number;
  remise_pct?: number;
  montant?: number;
};

export type Devis = {
  id: string;
  reference: string | null;
  objet: string | null;
  client_id: string | null;
  chantier_id: string | null;
  nature: string | null;
  date_devis: string | null;
  date_validite: string | null;
  tva_pct: number;
  tva_exonere: boolean;
  remise_globale_pct: number;
  montant_ht: number;
  tva_montant: number;
  montant_ttc: number;
  statut: DevisStatut;
  facture_id: string | null;
  notes: string | null;
  is_archived: boolean;
  lignes: LigneDevis[];
};

export type DevisInput = {
  objet?: string | null;
  client_id?: string | null;
  chantier_id?: string | null;
  nature?: string | null;
  date_devis?: string | null;
  date_validite?: string | null;
  tva_pct: number;
  tva_exonere: boolean;
  remise_globale_pct: number;
  notes?: string | null;
  lignes: { designation: string; unite?: string | null; quantite: number; prix_unitaire: number; remise_pct: number }[];
};

export type PageDevis = { items: Devis[]; total: number; page: number; size: number; pages: number };

export async function listDevis(params?: { statut?: DevisStatut; archives?: boolean; page?: number; size?: number }): Promise<PageDevis> {
  const { data } = await api.get<PageDevis>('/devis', { params });
  return data;
}
export async function getDevis(id: string): Promise<Devis> {
  const { data } = await api.get<Devis>(`/devis/${id}`);
  return data;
}
export async function createDevis(payload: DevisInput): Promise<Devis> {
  const { data } = await api.post<Devis>('/devis', payload);
  return data;
}
export async function updateDevis(id: string, payload: DevisInput): Promise<Devis> {
  const { data } = await api.put<Devis>(`/devis/${id}`, payload);
  return data;
}
export async function changerStatutDevis(id: string, statut: DevisStatut): Promise<Devis> {
  const { data } = await api.post<Devis>(`/devis/${id}/statut`, null, { params: { statut } });
  return data;
}
export async function deleteDevis(id: string): Promise<void> {
  await api.delete(`/devis/${id}`);
}
export async function openDevisPdf(id: string, reference?: string | null, mode: PdfMode = 'open'): Promise<void> {
  await renderPdf(`/devis/${id}/pdf`, undefined, mode, `Devis ${reference ?? id}.pdf`);
}
